import { inject } from '@angular/core';
import {
  RouterStateSnapshot,
  ResolveFn,
} from '@angular/router';
import { ClientAppUserUIProfileService } from '../services/client-app-user-uiprofile.service';


export const CustomLayoutResolver: ResolveFn<any> = (
  _route,
  state: RouterStateSnapshot
) => {
 
  const clientAppUserUIProfile = inject(ClientAppUserUIProfileService)
  clientAppUserUIProfile.ResetUserUiProfileFilled();
  clientAppUserUIProfile.cleanSubscribtions();
  let url = clientAppUserUIProfile.getUrlSignature(state.url);

  clientAppUserUIProfile.subscribeToFavoriteButtonToggle(url)

  clientAppUserUIProfile.subscribeToColumnConfigSave(url);

  clientAppUserUIProfile.handleSaveColumnLayoutEvent(url);
  clientAppUserUIProfile.GetScreenUserUIProfile(url);

  return null;
};
